export const toothDList = [
  {
    id: 1,
    numberOfTeeth: 1,
    teethingPeriod: 25,
    name: "A",
    description:
      "This is a placeholder tooth. No specific information available.",
  },
  {
    id: 3,
    numberOfTeeth: 1,
    teethingPeriod: 228,
    name: "Upper Right Third Molar",
    description:
      "Commonly known as the wisdom tooth, it erupts late and may require removal if impacted.",
  },
  {
    id: 4,
    numberOfTeeth: 2,
    teethingPeriod: 150,
    name: "Upper Right Second Molar",
    description:
      "Assists in grinding food and is positioned behind the first molar.",
  },
  {
    id: 5,
    numberOfTeeth: 3,
    teethingPeriod: 78,
    name: "Upper Right First Molar",
    description: "Plays a crucial role in chewing and breaking down food.",
  },
  {
    id: 6,
    numberOfTeeth: 4,
    teethingPeriod: 132,
    name: "Upper Right Second Premolar",
    description:
      "Located between the first premolar and first molar, it aids in chewing.",
  },
  {
    id: 7,
    numberOfTeeth: 5,
    teethingPeriod: 126,
    name: "Upper Right First Premolar",
    description:
      "Assists in tearing and grinding food, positioned next to the canine.",
  },
  {
    id: 8,
    numberOfTeeth: 6,
    teethingPeriod: 138,
    name: "Upper Right Canine",
    description:
      "A pointed tooth designed for tearing food, located at the corner of the mouth.",
  },
  {
    id: 9,
    numberOfTeeth: 7,
    teethingPeriod: 102,
    name: "Upper Right Lateral Incisor",
    description:
      "Assists the central incisor in cutting food, smaller in size.",
  },
  {
    id: 10,
    numberOfTeeth: 8,
    teethingPeriod: 90,
    name: "Upper Right Central Incisor",
    description: "One of the two front teeth, responsible for cutting food.",
  },
  {
    id: 11,
    numberOfTeeth: 9,
    teethingPeriod: 90,
    name: "Upper Left Central Incisor",
    description:
      "One of the two upper front teeth, crucial for biting into food.",
  },
  {
    id: 12,
    numberOfTeeth: 10,
    teethingPeriod: 102,
    name: "Upper Left Lateral Incisor",
    description:
      "Helps in cutting food, positioned next to the central incisor.",
  },
  {
    id: 13,
    numberOfTeeth: 11,
    teethingPeriod: 138,
    name: "Upper Left Canine",
    description:
      "Sharp tooth designed for tearing food, positioned beside lateral incisors.",
  },
  {
    id: 14,
    numberOfTeeth: 12,
    teethingPeriod: 126,
    name: "Upper Left First Premolar",
    description:
      "Assists in tearing and grinding food, positioned near the canine.",
  },
  {
    id: 15,
    numberOfTeeth: 13,
    teethingPeriod: 132,
    name: "Upper Left Second Premolar",
    description: "Aids in breaking down food before digestion.",
  },
  {
    id: 16,
    numberOfTeeth: 14,
    teethingPeriod: 78,
    name: "Upper Left First Molar",
    description: "Plays a vital role in grinding food for digestion.",
  },
  {
    id: 17,
    numberOfTeeth: 15,
    teethingPeriod: 150,
    name: "Upper Left Second Molar",
    description: "A strong tooth responsible for crushing and grinding food.",
  },
  {
    id: 18,
    numberOfTeeth: 16,
    teethingPeriod: 228,
    name: "Upper Left Third Molar",
    description: "A wisdom tooth that may require extraction if impacted.",
  },
  {
    id: 19,
    numberOfTeeth: 17,
    teethingPeriod: 228,
    name: "Lower Left Third Molar",
    description:
      "A wisdom tooth that erupts late, often removed due to space issues.",
  },
  {
    id: 20,
    numberOfTeeth: 18,
    teethingPeriod: 144,
    name: "Lower Left Second Molar",
    description: "A molar used for grinding food efficiently.",
  },
  {
    id: 21,
    numberOfTeeth: 19,
    teethingPeriod: 78,
    name: "Lower Left First Molar",
    description:
      "One of the main chewing teeth, essential for food processing.",
  },
  {
    id: 22,
    numberOfTeeth: 20,
    teethingPeriod: 138,
    name: "Lower Left Second Premolar",
    description:
      "A premolar responsible for breaking down food before swallowing.",
  },
  {
    id: 23,
    numberOfTeeth: 21,
    teethingPeriod: 132,
    name: "Lower Left First Premolar",
    description: "Works alongside the canine to tear food into smaller pieces.",
  },
  {
    id: 24,
    numberOfTeeth: 22,
    teethingPeriod: 114,
    name: "Lower Left Canine",
    description: "A sharp tooth used for tearing food apart.",
  },
  {
    id: 25,
    numberOfTeeth: 23,
    teethingPeriod: 90,
    name: "Lower Left Lateral Incisor",
    description: "Small but essential for cutting food before chewing.",
  },
  {
    id: 26,
    numberOfTeeth: 24,
    teethingPeriod: 78,
    name: "Lower Left Central Incisor",
    description: "One of the smallest teeth, helps in biting off food pieces.",
  },
  {
    id: 27,
    numberOfTeeth: 25,
    teethingPeriod: 78,
    name: "Lower Right Central Incisor",
    description: "Plays an important role in cutting food into smaller pieces.",
  },
  {
    id: 28,
    numberOfTeeth: 26,
    teethingPeriod: 90,
    name: "Lower Right Lateral Incisor",
    description: "Helps in biting and cutting food into chewable portions.",
  },
  {
    id: 29,
    numberOfTeeth: 27,
    teethingPeriod: 114,
    name: "Lower Right Canine",
    description: "A strong, pointed tooth used for tearing food.",
  },
  {
    id: 30,
    numberOfTeeth: 28,
    teethingPeriod: 132,
    name: "Lower Right First Premolar",
    description: "Works with molars to grind food before digestion.",
  },
  {
    id: 31,
    numberOfTeeth: 29,
    teethingPeriod: 138,
    name: "Lower Right Second Premolar",
    description: "Helps in chewing and grinding food.",
  },
  {
    id: 32,
    numberOfTeeth: 30,
    teethingPeriod: 78,
    name: "Lower Right First Molar",
    description: "A strong tooth responsible for food grinding.",
  },
  {
    id: 33,
    numberOfTeeth: 31,
    teethingPeriod: 144,
    name: "Lower Right Second Molar",
    description: "Used for grinding and chewing food thoroughly.",
  },
  {
    id: 34,
    numberOfTeeth: 32,
    teethingPeriod: 228,
    name: "Lower Right Third Molar",
    description: "A wisdom tooth that may require extraction if problematic.",
  },
];
